
import Services from '../../service/ApiServices'
export const GET_TOKEN = "GET_TOKEN"


export const GetToken = async (username)=>{
    var response = await Services.Authorization.getToken(username) 
    localStorage.setItem('app', JSON.stringify({token:response.token, roles: JSON.stringify(response.roles)})) 
    return {type: GET_TOKEN, token:response.token, roles:response.roles}
}